<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PaymentPackage",

  computed: {
    ...mapGetters(["isAuthenticated"]),
  },

  data() {
    return {
      package: this.$route.params.package,
    };
  },

  mounted() {
    this.validateAuth();
  },

  methods: {
    validateAuth() {
      if (this.isAuthenticated)
        this.$router.push({
          name: "ParentUpgradePlan",
          query: { type: this.package },
        });
      else {
        localStorage.setItem("paymentRedirect", this.package);
        this.$router.push({ name: "ParentSignup" });
      }
    },
  },
};
</script>

<style></style>
